<template>
  <v-row
    class="segmented-progress mx-5 mb-2"
    no-gutters
  >
    <v-col
      v-for="(value, index) in progressArray"
      :key="index"
      :class="[
        'segment',
        value === 1 ? 'filled' : '',
        index === 0 ? 'first' : '',
        index === progressArray.length - 1 ? 'last' : '',
        isStartOfFilled(index) ? 'start-filled' : '',
        isEndOfFilled(index) ? 'end-filled' : ''
      ]"
      :style="{backgroundColor: value === 1 ? `var(${filledColor})` : emptyColor}"
    />
  </v-row>
</template>

  <script>
import { getDefenceReadinessItems } from '../utils'

export default {
  dataStore: {
    BankReadiness: 'RiskLiquidity.BankReadiness.Data',
    TotalItems   : 'RiskLiquidity.BankReadiness.TotalItems',
    CurrentPage  : 'RiskLiquidity.BankReadiness.CurrentPage'
  },
  props: {
    financialInstrumentKey: {
      type   : String,
      default: 'availableCash'
    },
    emptyColor: {
      type   : String,
      default: 'white'
    },
    height: {
      type   : String,
      default: '12px'
    },
    radius: {
      type   : String,
      default: '8px'
    },
    currentPage: {
      type   : Number,
      default: 1
    }
  },
  computed: {
    filledColor () {
      return this.$t(`RiskLiquidity.Section.DefenceReadiness.MildCrisisAssumptions.${this.financialInstrumentKey}.Color`)
    },
    progressArray () {
      if (!this.BankReadiness || !this.BankReadiness.items) {
        return []
      }
      const data = []
      this.BankReadiness.items.forEach(item => {
        if (item[this.financialInstrumentKey] !== 0) {
          data.push(1)
        } else {
          data.push(0)
        }
      })
      return getDefenceReadinessItems(data, this.currentPage)
    }
  },
  mounted () {
  },
  methods: {
    isStartOfFilled (index) {
      return (
        this.progressArray[index] === 1 &&
        (index === 0 || this.progressArray[index - 1] === 0)
      )
    },
    isEndOfFilled (index) {
      return (
        this.progressArray[index] === 1 &&
        (index === this.progressArray.length - 1 ||
          this.progressArray[index + 1] === 0)
      )
    }
  }
}
  </script>

  <style scoped>
  .segmented-progress {
    display: flex;
    height: var(--height, 12px);
  }

  .segment {
    flex: 1;
    margin: 0; /* no gap */
    transition: background-color 0.3s;
  }

  .start-filled {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .end-filled {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .first {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .last {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  </style>
